export default __webpack_public_path__ + "static/media/Carly 9781408327890.9949dfdd.jpg";